export default __webpack_public_path__ + "navigation-examples-electronic-horizon-960-3717afab90793e0a16c1ac8a61e565fd.png";